var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRupeecolour(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 35.75C28.4749 35.75 35.75 28.4749 35.75 19.5C35.75 10.5251 28.4749 3.25 19.5 3.25C10.5251 3.25 3.25 10.5251 3.25 19.5C3.25 28.4749 10.5251 35.75 19.5 35.75ZM21.9375 13C22.4705 13.7085 22.8524 14.5372 23.0344 15.4375H26V17.875H23.0344C22.7534 19.2514 22.0055 20.4885 20.9173 21.3768C19.829 22.2652 18.4673 22.7503 17.0625 22.75H16.7538L22.7987 28.795L21.0763 30.5175L13 22.4413V20.3125H17.0625C17.8188 20.3127 18.5565 20.0784 19.1741 19.6419C19.7917 19.2053 20.2587 18.588 20.5107 17.875H13V15.4375H20.5107C20.2587 14.7245 19.7917 14.1072 19.1741 13.6706C18.5565 13.2341 17.8188 12.9998 17.0625 13H13V10.5625H26V13H21.9375Z",
    fill: "url(#paint0_linear_2570_4156)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2570_4156",
    x1: 19.5,
    y1: 3.25,
    x2: 19.5,
    y2: 35.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD705"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6BB4B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRupeecolour);
export default __webpack_public_path__ + "static/media/Rupee colour.dafefc4d791c50994fd9656602e010fc.svg";
export { ForwardRef as ReactComponent };